import { Box, Group, useMantineColorScheme } from '@mantine/core';
import useCurrentUser from '../../../../hooks/useCurrentUser';

export default function Brand() {
  const [currentUser] = useCurrentUser();
  const { colorScheme } = useMantineColorScheme({});

  return (
    <Box
      style={(theme) => ({
        paddingBottom: theme.spacing.lg,
        borderBottom: `1px solid ${colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]}`,
      })}
    >
      <Group justify="center">
        {currentUser.executivo ? (
          <>
            <img alt="KWM" src={`${process.env.PUBLIC_URL}/assets/kwm.png`} style={{ maxWidth: 140 }} />
            <img
              alt="Performa"
              src={`${process.env.PUBLIC_URL}/assets/performa.jpg`}
              style={{ maxWidth: 140 }}
            />
          </>
        ) : (
          <img
            alt={`${currentUser.empresa}`}
            src={
              currentUser.empresa === 'Performa'
                ? 'https://performa.eco.br/wp-content/uploads/2020/12/perfoma-servicos-ambientais.png'
                : 'https://www.kwm.eco.br/wp-content/uploads/2021/02/post-1.png'
            }
            style={{ maxWidth: 285 }}
          />
        )}
      </Group>
    </Box>
  );
}
